import { AppsRegular, GlobeSearchRegular } from "@fluentui/react-icons";

export const getPluginIcon = (plugin?: string) => {
    if (!plugin) {
        return <AppsRegular />;
    }
    
    const icons: { [id: string]: JSX.Element } = {
        'websearch': <GlobeSearchRegular />
    };

    return icons[plugin] ?? <AppsRegular />
}